import "../redesign.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { domainUrl } from "app/Api/axios";
import { useLocation } from "react-router-dom";

/* ── Timesheet mockup sub-components ── */
const TsMockEmployee = () => (
  <div>
    <table className="tt-ts-grid">
      <thead>
        <tr>
          <th>Project</th><th>Mon</th><th>Tue</th><th>Wed</th><th>Thu</th><th>Fri</th><th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><span className="tt-ts-dot tt-ts-dot--approved"/>TimeTango Dev</td>
          <td>8.0</td><td>7.5</td><td style={{border:'1.5px solid var(--tt-magenta)',borderRadius:6,background:'rgba(184,28,212,0.04)'}}>8.0</td><td>8.0</td><td>6.0</td><td style={{fontWeight:600}}>37.5</td>
        </tr>
        <tr>
          <td><span className="tt-ts-dot tt-ts-dot--submitted"/>Mobile App</td>
          <td>4.0</td><td>3.5</td><td>4.0</td><td>4.0</td><td>2.0</td><td style={{fontWeight:600}}>17.5</td>
        </tr>
        <tr>
          <td><span className="tt-ts-dot tt-ts-dot--draft"/>Desktop Agent</td>
          <td>—</td><td>1.0</td><td>—</td><td>—</td><td>—</td><td style={{fontWeight:600}}>1.0</td>
        </tr>
      </tbody>
    </table>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:10}}>
      <div style={{display:'flex',gap:12,fontSize:10,color:'var(--tt-muted)'}}>
        <span><span className="tt-ts-dot tt-ts-dot--draft"/>Draft</span>
        <span><span className="tt-ts-dot tt-ts-dot--submitted"/>Submitted</span>
        <span><span className="tt-ts-dot tt-ts-dot--approved"/>Approved</span>
        <span><span className="tt-ts-dot tt-ts-dot--rejected"/>Rejected</span>
      </div>
      <span className="tt-ts-pill tt-ts-pill--submit">Submit week</span>
    </div>
  </div>
);

const TsMockApproval = () => (
  <div>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
      <span style={{fontSize:12,fontWeight:600,color:'var(--tt-ink)'}}>Pending Approval</span>
      <span className="tt-ts-pill tt-ts-pill--approve">Approve all (3)</span>
    </div>
    <table className="tt-ts-grid">
      <thead><tr><th>Employee</th><th>Project</th><th>Hours</th><th>Action</th></tr></thead>
      <tbody>
        <tr><td>John Doe</td><td>TimeTango Dev</td><td>37.5h</td>
          <td><span className="tt-ts-action-btn tt-ts-action-btn--approve">✓</span>{' '}<span className="tt-ts-action-btn tt-ts-action-btn--reject">✕</span></td>
        </tr>
        <tr><td>Priya Sharma</td><td>Mobile App</td><td>32.0h</td>
          <td><span className="tt-ts-action-btn tt-ts-action-btn--approve">✓</span>{' '}<span className="tt-ts-action-btn tt-ts-action-btn--reject">✕</span></td>
        </tr>
        <tr style={{opacity:0.6}}><td>Arun Kumar</td><td>Desktop Agent</td><td>28.0h</td>
          <td><span style={{fontSize:11,color:'var(--tt-green)',fontWeight:600}}>✓ Approved</span></td>
        </tr>
      </tbody>
    </table>
  </div>
);

const TsMockClient = () => (
  <div style={{textAlign:'center',padding:'12px 0'}}>
    <img src="/assets/logo3.svg" alt="TimeTango" style={{height:22,marginBottom:12}}/>
    <div style={{fontSize:14,fontWeight:600,color:'var(--tt-ink)',marginBottom:4}}>Approve contractor timesheet</div>
    <div style={{fontSize:11,color:'var(--tt-muted)',marginBottom:12}}>John Doe · Week Jul 7–11 · TimeTango Dev · <strong>37.5h</strong></div>
    <div style={{display:'flex',gap:10,justifyContent:'center',marginBottom:12}}>
      <span className="tt-ts-action-btn tt-ts-action-btn--approve" style={{padding:'8px 24px',fontSize:13,borderRadius:10}}>✓ Approve</span>
      <span className="tt-ts-pill tt-ts-pill--reject" style={{padding:'8px 24px',fontSize:13}}>Reject</span>
    </div>
    <div style={{fontSize:10,color:'var(--tt-muted)'}}>🔒 Secure token link — no account needed</div>
  </div>
);

const TsMockReport = () => (
  <div>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
      <span style={{fontSize:12,fontWeight:600,color:'var(--tt-ink)'}}>Weekly Summary</span>
      <span className="tt-ts-pill tt-ts-pill--export">Export to Excel</span>
    </div>
    <table className="tt-ts-grid">
      <thead><tr><th>Employee / Project</th><th>Mon</th><th>Tue</th><th>Wed</th><th>Thu</th><th>Fri</th><th>Total</th></tr></thead>
      <tbody>
        <tr style={{fontWeight:600,background:'var(--tt-tinted)'}}><td>▾ John Doe</td><td>12.0</td><td>12.0</td><td>12.0</td><td>12.0</td><td>8.0</td><td style={{color:'var(--tt-magenta)',fontWeight:700}}>56.0</td></tr>
        <tr><td style={{paddingLeft:20}}>TimeTango Dev</td><td>8.0</td><td>7.5</td><td>8.0</td><td>8.0</td><td>6.0</td><td>37.5</td></tr>
        <tr><td style={{paddingLeft:20}}>Mobile App</td><td>4.0</td><td>3.5</td><td>4.0</td><td>4.0</td><td>2.0</td><td>17.5</td></tr>
        <tr><td style={{paddingLeft:20}}>Desktop Agent</td><td>—</td><td>1.0</td><td>—</td><td>—</td><td>—</td><td>1.0</td></tr>
      </tbody>
    </table>
  </div>
);

/* ── Feature rows data ── */
const features = [
  {
    eyebrow: 'Attendance management',
    title: 'Photo-verified check-ins across every device',
    desc: 'Employees check in with a selfie on mobile, desktop or a shared kiosk — GPS coordinates, timestamp and facial match are recorded instantly.',
    img: '/assets/img/hero/Hero_Attendance_management.webp',
    flow: ['Tap check-in', 'Face verify', 'Marked present'],
    link: '/solutions/attendance',
  },
  {
    eyebrow: 'Activity tracking',
    title: 'See how teams spend their workday',
    desc: 'The lightweight desktop agent captures active apps and idle time. Admins get productivity breakdowns without micromanaging.',
    img: '/assets/img/activity_tracking.jpg',
    flow: ['App runs', 'Captures activity', 'Insights report'],
    reversed: true,
    link: '/solutions/activity-tracking',
  },
  {
    eyebrow: 'Leave management',
    title: 'Apply, approve and balance — in one flow',
    desc: 'Employees apply for leave from their phone, supervisors approve with a tap, and balances update in real time. Supports accruals, LOP and sandwich policies.',
    img: '/assets/img/leave_management.webp',
    flow: ['Apply leave', 'Manager approves', 'Balance updates'],
    link: '/solutions/leave',
  },
  {
    eyebrow: 'GPS & geo-fencing',
    title: 'Location-aware attendance at every site',
    desc: 'Define virtual perimeters for offices, warehouses or client locations. When an employee steps inside the fence, attendance is auto-triggered.',
    img: '/assets/img/geo-fencing_capabilities.png',
    flow: ['Enter geo-fence', 'Auto check-in', 'Location logged'],
    reversed: true,
    link: '/solutions/attendance',
  },
];

/* Use-case icons as styled SVG-like elements instead of emojis (per ui-ux-pro-max no-emoji-icons rule) */
const UseCaseIcon = ({ type }) => {
  const styles = {
    base: { width: 48, height: 48, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, fontWeight: 700, marginBottom: 12 },
    it: { background: 'linear-gradient(135deg, rgba(224,89,240,0.12), rgba(152,149,244,0.12))', color: 'var(--tt-magenta)' },
    mfg: { background: 'linear-gradient(135deg, rgba(26,158,87,0.1), rgba(26,158,87,0.05))', color: 'var(--tt-green)' },
    retail: { background: 'linear-gradient(135deg, rgba(201,134,10,0.1), rgba(201,134,10,0.05))', color: 'var(--tt-amber)' },
    remote: { background: 'linear-gradient(135deg, rgba(125,108,240,0.12), rgba(152,149,244,0.08))', color: 'var(--tt-violet-deep)' },
  };
  const icons = { it: '{ }', mfg: '⚙', retail: '◉', remote: '⊕' };
  return <div style={{...styles.base, ...styles[type]}}>{icons[type]}</div>;
};

const useCases = [
  { type: 'it', title: 'IT & Software', desc: 'Track remote devs, hybrid teams and billable project hours.' },
  { type: 'mfg', title: 'Manufacturing', desc: 'Shift management, overtime tracking and shop-floor attendance.' },
  { type: 'retail', title: 'Retail Chains', desc: 'Multi-location check-ins with GPS for every store.' },
  { type: 'remote', title: 'Remote Teams', desc: 'WFH support with activity tracking and idle alerts.' },
];

const testimonials = [
  { quote: 'TimeTango streamlined our daily attendance process. Photo-verified check-ins mean zero buddy-punching.', name: 'Shraddha B.', role: 'HR Lead, HighLeap Education' },
  { quote: 'Switching to TimeTango saved us 10+ hours a month on attendance reconciliation alone.', name: 'D. Kishor', role: 'Operations, Balaji Enterprises' },
  { quote: 'The activity tracker gives me real insight into how my distributed team works — without being intrusive.', name: 'Arun Kumar', role: 'CTO, Techspark Solutions' },
];

const chipCloud = ['GPS tracking', 'Biometric & facial', 'Geo-fencing', 'Leave management', 'Productivity analytics', 'Payroll-ready reports', 'Timesheets'];

/* ── Flow snippet with animation ── */
const FlowSnippet = ({ steps }) => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const iv = setInterval(() => setActive(a => (a + 1) % steps.length), 1300);
    return () => clearInterval(iv);
  }, [steps.length]);
  return (
    <div className="tt-flow">
      {steps.map((s, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className={`tt-flow__arrow ${active >= i ? 'tt-flow__arrow--active' : ''}`}>→</span>}
          <div className={`tt-flow__step ${active === i ? 'tt-flow__step--active' : ''}`}>{s}</div>
        </React.Fragment>
      ))}
    </div>
  );
};

/* ── Timesheet cycling section ── */
const TimesheetSection = () => {
  const [activeIdx, setActiveIdx] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const steps = ['Log hours', 'Admin approves', 'Client signs off', 'Weekly report'];
  const mockups = [<TsMockEmployee key={0}/>, <TsMockApproval key={1}/>, <TsMockClient key={2}/>, <TsMockReport key={3}/>];

  useEffect(() => {
    const iv = setInterval(() => {
      setActiveIdx(i => (i + 1) % 4);
      setActiveStep(s => (s + 1) % 4);
    }, 3000);
    return () => clearInterval(iv);
  }, []);

  return (
    <div className="tt-section">
      <div className="tt-wrap--grid">
        <div className="tt-feat">
          <div className="tt-feat__text">
            <span className="tt-eyebrow">Timesheet management & approval</span>
            <h3>Log, approve and report in one flow</h3>
            <p>Employees enter daily hours in a weekly grid, admins approve with a click, clients sign off via a secure link, and the weekly summary exports to Excel.</p>
            <div className="tt-flow" style={{marginTop:8}}>
              {steps.map((s, i) => (
                <React.Fragment key={i}>
                  {i > 0 && <span className={`tt-flow__arrow ${activeStep >= i ? 'tt-flow__arrow--active' : ''}`}>→</span>}
                  <div className={`tt-flow__step ${activeStep === i ? 'tt-flow__step--active' : ''}`}>{s}</div>
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="tt-feat__img">
            <div className="tt-mock-browser">
              <div className="tt-mock-browser__bar">
                <span className="tt-mock-browser__dot tt-mock-browser__dot--r"/>
                <span className="tt-mock-browser__dot tt-mock-browser__dot--y"/>
                <span className="tt-mock-browser__dot tt-mock-browser__dot--g"/>
                <span className="tt-mock-browser__title">TimeTango · Timesheets</span>
              </div>
              <div className="tt-mock-browser__body" style={{minHeight:260,position:'relative'}}>
                {mockups.map((m, i) => (
                  <div key={i} className={`tt-ts-card ${activeIdx === i ? 'tt-ts-card--active' : ''}`}>
                    {m}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ════════ MAIN COMPONENT ════════ */
const HomePageRedesign = ({ showTestimonials = true }) => {
  const location = useLocation();
  const canonicalURL = `${domainUrl}${location.pathname === '/' ? '' : location.pathname}`;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "TimeTango — Employee Attendance & Workforce Management",
    image: "https://timetango.in/assets/img/hero/Hero_Combine.webp",
    description: "All-in-one employee attendance, activity tracking, leave management and HRMS platform for desktop, web and mobile.",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, Android, iOS, Windows, macOS",
    brand: { "@type": "Brand", name: "TimeTango", logo: "https://timetango.in/assets/logo3.svg" },
    offers: { "@type": "Offer", url: "https://timetango.in/pricing", priceCurrency: "INR", price: "1500" },
  };

  return (
    <div className="tt-page">
      <Helmet>
        <title>TimeTango — All-in-One Attendance & Workforce Management | From ₹30/user</title>
        <meta name="description" content="Photo-verified check-ins, live activity insight and effortless leave — synced across desktop, web and mobile. Trusted by 500+ businesses. Starting at ₹30/user/month." />
        <meta property="og:title" content="TimeTango — All-in-One Attendance & Workforce Management" />
        <meta property="og:description" content="Photo-verified check-ins, live activity insight and effortless leave — synced across every device in real time. From ₹30/user/month." />
        <meta property="og:image" content="https://timetango.in/assets/img/hero/Hero_Combine.webp" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalURL} />
        <link rel="canonical" href={canonicalURL} />
        <meta property="og:site_name" content="TimeTango" />
        <meta name="language" content="english" />
        <meta name="robots" content="index, follow" />
        <meta name="google-site-verification" content="HeqJ8arMIZIDpCmRH1zlrNu601VS7Wp92JoTy_9bARM" />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      {/* ── HERO ── */}
      <section className="tt-hero">
        <div className="tt-wrap">
          <div className="tt-eyebrow-pill">Desktop · Web · Mobile — one real-time platform</div>
          <h1>All-in-one attendance &amp; <span className="tt-grad-text">workforce management</span></h1>
          <p className="tt-hero__sub">
            Photo-verified check-ins, live activity insight and effortless leave — synced across every device in real time. <strong>From ₹30 / user / month.</strong>
          </p>
          <div className="tt-hero__ctas">
            <Link to="/company-register" className="tt-btn tt-btn--grad tt-btn--pill tt-btn--lg">Start free trial →</Link>
            <a href="https://calendly.com/amol-amlapure" target="_blank" rel="noreferrer" className="tt-btn tt-btn--white tt-btn--pill tt-btn--lg">▶ Watch 2-min tour</a>
          </div>
          <div className="tt-hero__img-wrap">
            {/* Floating chips */}
            <div className="tt-chip tt-chip--1"><span className="tt-chip__dot"/>Live now · 143 present</div>
            <div className="tt-chip tt-chip--2">Priya checked in ✓ Photo verified</div>
            <div className="tt-chip tt-chip--3">Idle time this week ▼ 23% lower</div>
            <div className="tt-chip tt-chip--4">📍 GPS · on-site</div>
            <div className="tt-hero__img-panel">
              <img src="/assets/img/hero/Hero_Combine.webp" alt="TimeTango dashboard — attendance, activity tracking, leave management" />
            </div>
          </div>
        </div>
      </section>

      {/* ── TRUST BAR ── */}
      <div className="tt-trust">
        <div className="tt-trust__inner">
          <span>Trusted by companies in</span>
          <span><span className="tt-trust__flag">🇮🇳</span> India</span>
          <span><span className="tt-trust__flag">🇺🇸</span> USA</span>
          <span><span className="tt-trust__flag">🇬🇧</span> UK</span>
          <span><span className="tt-trust__flag">🇦🇪</span> UAE</span>
          <span>· <strong>500+ businesses</strong> · <strong>2M+ check-ins</strong> logged</span>
        </div>
      </div>

      {/* ── FEATURES INTRO ── */}
      <section className="tt-section" style={{textAlign:'center'}}>
        <div className="tt-wrap">
          <span className="tt-eyebrow">How it works</span>
          <h2 style={{fontSize:40,maxWidth:600,margin:'0 auto 16px'}}>See every feature in flow</h2>
          <p style={{fontSize:17,maxWidth:600,margin:'0 auto 28px',color:'var(--tt-body)'}}>
            From check-in to payroll report — each module works standalone and connects seamlessly when you need the full picture.
          </p>
          <div style={{display:'flex',flexWrap:'wrap',gap:10,justifyContent:'center'}}>
            {chipCloud.map(c => <span key={c} className="tt-eyebrow-pill" style={{fontSize:13,padding:'6px 14px'}}>{c}</span>)}
          </div>
        </div>
      </section>

      {/* ── FEATURE ROWS ── */}
      {features.map((f, idx) => (
        <section key={idx} className={`tt-section ${f.reversed ? 'tt-section--tinted' : ''}`}>
          <div className="tt-wrap--grid">
            <div className={`tt-feat ${f.reversed ? 'tt-feat--rev' : ''}`}>
              <div className="tt-feat__text">
                <span className="tt-eyebrow">{f.eyebrow}</span>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
                <FlowSnippet steps={f.flow} />
                {f.link && <Link to={f.link} style={{display:'inline-block',marginTop:12,fontSize:14,fontWeight:600,color:'var(--tt-magenta)',textDecoration:'none'}}>Learn more →</Link>}
              </div>
              <div className="tt-feat__img">
                <div className="tt-feat__img-panel">
                  <img src={f.img} alt={f.eyebrow} />
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* ── TIMESHEET SECTION ── */}
      <TimesheetSection />

      {/* ── USE CASES ── */}
      <section className="tt-section tt-section--tinted" style={{textAlign:'center'}}>
        <div className="tt-wrap--grid">
          <span className="tt-eyebrow">Built for every industry</span>
          <h2 style={{fontSize:36,marginBottom:32}}>Who uses TimeTango?</h2>
          <div className="tt-usecases">
            {useCases.map(u => (
              <div key={u.title} className="tt-usecase-card">
                <UseCaseIcon type={u.type} />
                <h4>{u.title}</h4>
                <p>{u.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      {showTestimonials && (
        <section className="tt-section" style={{textAlign:'center'}}>
          <div className="tt-wrap--grid">
            <span className="tt-eyebrow">What our customers say</span>
            <h2 style={{fontSize:36,marginBottom:32}}>Trusted by growing teams</h2>
            <div className="tt-testimonials">
              {testimonials.map(t => (
                <div key={t.name} className="tt-testimonial-card">
                  <p>"{t.quote}"</p>
                  <div className="tt-testimonial-card__author">{t.name}</div>
                  <div className="tt-testimonial-card__role">{t.role}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ── PRICING ANCHOR ── */}
      <section className="tt-section tt-section--tinted">
        <div className="tt-wrap--cta">
          <div className="tt-pricing-anchor">
            <div>
              <span className="tt-eyebrow">Simple pricing</span>
              <h2 style={{fontSize:32,marginBottom:12}}>Everything, from ₹30 a user</h2>
              <p style={{fontSize:16,marginBottom:24}}>Attendance, leave, activity tracking, timesheets and more — one platform, one price.</p>
              <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
                <Link to="/company-register" className="tt-btn tt-btn--grad tt-btn--pill">Start free trial →</Link>
                <Link to="/pricing" className="tt-btn tt-btn--outline tt-btn--pill">See all plans</Link>
              </div>
            </div>
            <div className="tt-card" style={{padding:'28px 32px',textAlign:'center',minWidth:200}}>
              <div style={{fontSize:14,color:'var(--tt-muted)',marginBottom:8}}>Starting at</div>
              <div className="tt-grad-text" style={{fontFamily:"'Space Grotesk',sans-serif",fontSize:48,fontWeight:700}}>₹30</div>
              <div style={{fontSize:13,color:'var(--tt-muted)',marginBottom:16}}>/ user / month</div>
              <div style={{textAlign:'left',fontSize:13,color:'var(--tt-body)'}}>
                {['GPS attendance','Leave management','Activity tracking','Timesheets & reports'].map(c => (
                  <div key={c} style={{padding:'4px 0'}}>✓ {c}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FINAL CTA ── */}
      <section className="tt-section">
        <div className="tt-wrap--cta">
          <div className="tt-cta-band">
            <h2>Experience the future of attendance today</h2>
            <p>Join 500+ companies already using TimeTango to track attendance, manage leaves and boost productivity.</p>
            <div style={{display:'flex',gap:14,justifyContent:'center',flexWrap:'wrap'}}>
              <Link to="/company-register" className="tt-btn tt-btn--white tt-btn--pill tt-btn--lg">Register your company →</Link>
              <a href="https://calendly.com/amol-amlapure" target="_blank" rel="noreferrer" className="tt-btn tt-btn--pill tt-btn--lg" style={{background:'rgba(255,255,255,0.15)',color:'#fff',border:'1px solid rgba(255,255,255,0.3)'}}>Schedule a demo</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePageRedesign;
